var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 body-2-2 text-14 text-subcolor"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('span',{staticClass:"font-bold text-dark"},[_vm._v(_vm._s(_vm.highlightedAmount))]),_vm._v(" "),_c('span',{staticClass:"text-12"},[_vm._v("· "+_vm._s(_vm.chargeInfo.rateLabel))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21808bdf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/payment/PaymentChargeInfo.vue
// module id = null
// module chunks = 